import { NEXT_JS_SERVER_COMPONENT_DEFAULT_CACHING_STRATEGY } from "@nimble/react-requests/api-clients/caching-strategy";
import { useQuery } from "@tanstack/react-query";

import { getDistrictAutocomplete } from "@/lib/api-clients/candidate-api-client";

export default function useDistrictsAutocomplete(
  districts?: string[] | null,
  search?: string | null,
  states?: string[] | null,
) {
  return useQuery({
    queryKey: [`district-autocomplete`, search, districts, states],
    queryFn: () =>
      getDistrictAutocomplete(
        NEXT_JS_SERVER_COMPONENT_DEFAULT_CACHING_STRATEGY,
      )(districts, search, states),
  });
}
